import * as yup from 'yup';
import { useFormHandler } from './useFormHandler';

export type TipByCategoryFormValues = {
  name: string;
  description: string;
};

export interface TipFormValues {
  category: string;
  title: string;
  audioFile?: File;
  description: string;
  text?: string;
  type: string;
  isPublished: boolean;
  [key: string]: string | File | boolean | undefined;
}

export const tipByCategoryValidationSchema = yup.object({
  name: yup.string().required('Le nom est obligatoire'),
  description: yup
    .string()
    .required('La description est obligatoire')
    .default('test'),
});

export const tipValidationSchema = yup.object({
  category: yup.string().required('La catégorie est obligatoire'),
  title: yup.string().required('Le titre est obligatoire'),
  audioFile: yup.mixed<File>(),
  text: yup.string(),
  description: yup
    .string()
    .required('La description est obligatoire')
    .default('test'),
  type: yup.string().required('Le type est obligatoire'),
  isPublished: yup.boolean().default(false),
});

export const useTipByCategoryForm = () => {
  const {
    handleSubmit: handleSubmitTipByCategory,
    register: registerTipByCategory,
    errors: errorsTipByCategory,
    reset: resetTipByCategory,
  } = useFormHandler<TipByCategoryFormValues>(tipByCategoryValidationSchema);

  const {
    handleSubmit: handleSubmitTip,
    register: registerTip,
    errors: errorsTip,
    reset: resetTip,
    setValue: setValueTip,
    control,
  } = useFormHandler<TipFormValues>(tipValidationSchema);

  return {
    handleSubmitTipByCategory,
    registerTipByCategory,
    errorsTipByCategory,
    resetTipByCategory,
    handleSubmitTip,
    registerTip,
    errorsTip,
    resetTip,
    setValueTip,
    control,
  };
};
